import { MouseEventHandler, createElement, useCallback } from 'react';
import { useHasActiveSubscription } from 'src/entities/subscription';
import { useModal } from 'src/shared/modalProvider';
import { HOC } from 'src/shared/componentBuilder';
import { useStartBillingSubscription } from './useStartSubscription';

type AnyFunction = (...args: never[]) => any;

export const useSubscriptionInterceptor = <T extends AnyFunction>(fn?: T) => {
  const hasSubscription = useHasActiveSubscription();
  const [startSubscription] = useStartBillingSubscription();
  const { closeModal } = useModal();
  return useCallback(
    async (...args: Parameters<T>): Promise<Awaited<ReturnType<T>>> => {
      if (hasSubscription) {
        return fn?.(...args);
      }
      closeModal();
      await startSubscription();
      // TODO: Отключено пока start Subscription использует старый механизм модалок тк они не имеют обратной связи
      return { error: new Error('Нужно выбрать тариф и оплатить подписку') } as unknown as Promise<Awaited<ReturnType<T>>>;
    },
    [fn, hasSubscription, startSubscription, closeModal],
  );
};

export const withSubscriptionClick: HOC<{ onClick?: MouseEventHandler<HTMLElement> }> = (component) => 
  ({ onClick, ...props }) => createElement(component, { ...props, onClick: useSubscriptionInterceptor(onClick) });